import axios from 'axios';
import get from 'lodash/get';
import { defineStore } from 'pinia';
import { useTradeStore } from './trade';

export enum SymbolType {
  /**
   * U 本位 包括USDC和USDT
   */
  USDT = 1,
  /**
   * 币本位
   */
  COIN = 2,
}

export interface Contract {
  /**
   * contract id. 合约ID
   */
  contract_id: number;
  /**
   * contract's index id.指数ID
   */
  index_id: number;
  /**
   * contract's name 合约名称
   */
  name: string;
  /**
   * 图标
   */
  icon_url: string;
}

export interface ContractInfo {
  contract: Contract;
  symbolType: SymbolType;
}

export const useFuturesStore = defineStore('futures', {
  state: () => {
    return {
      baseSymbolsInfo: {} as Record<number, ContractInfo>,
      contractIdByName: {},
      simulationSymbolsInfo: {} as Record<number, ContractInfo>,
      simulationContractIdByName: {},
      quotationSymbolsInfo: {}, // 交易对行情信息， ws 获得  ex.{1: {}, 2: {}}
    };
  },
  getters: {
    availableSymbolIds() {
      const tradeStore = useTradeStore();
      const list: number[] = [];
      Object.keys(this.baseSymbolsInfo).forEach(id => {
        if (!tradeStore.privateCoinNames.includes(this.baseSymbolsInfo[id]?.contract?.base_coin)) {
          list.push(+id);
        }
      });
      return list;
    },
    availableSimulationSymbolIds() {
      const tradeStore = useTradeStore();
      const list: number[] = [];
      Object.keys(this.simulationSymbolsInfo).forEach(id => {
        if (!tradeStore.privateCoinNames.includes(this.simulationSymbolsInfo[id]?.contract?.base_coin)) {
          list.push(+id);
        }
      });
      return list;
    },
  },
  actions: {
    UPDATE_SYMBOL_PRICE(data: any) {
      const { quotationSymbolsInfo } = this;
      const finalInfo = Object.assign({}, quotationSymbolsInfo);
      data.forEach(item => {
        finalInfo[item.contract_id] = item;
      });
      this.quotationSymbolsInfo = finalInfo;
    },
    SET_CONTRACT_INFOS(contracts: Omit<ContractInfo, 'symbolType'>[]) {
      const symbolObj: Record<number, ContractInfo> = {};
      const idByName: Record<string, number> = {};
  
      contracts.forEach(obj => {
        const contractId = obj.contract.contract_id;
  
        symbolObj[contractId] = {
          contract: obj.contract,
          symbolType: obj.contract.base_coin === obj.contract.price_coin ? SymbolType.USDT : SymbolType.COIN,
        };
        idByName[obj.contract.name] = contractId;
      });
      this.baseSymbolsInfo = symbolObj;
      this.contractIdByName = idByName;
    },
    SET_SIMULATION_CONTRACT_INFOS(contracts: Omit<ContractInfo, 'symbolType'>[]) {
      const symbolObj: Record<number, ContractInfo> = {};
      const idByName: Record<string, number> = {};
  
      contracts.forEach(obj => {
        const contractId = obj.contract.contract_id;
  
        symbolObj[contractId] = {
          contract: obj.contract,
          symbolType: obj.contract.base_coin === obj.contract.price_coin ? SymbolType.USDT : SymbolType.COIN,
        };
        idByName[obj.contract.name] = contractId;
  
        // 模拟交易时，合约名称会变成 USDX 的，需要兼容
        if (obj.contract.name.includes('USDX')) {
          idByName[obj.contract.name.replace('USDX', 'USDT')] = contractId;
        }
      });
      this.simulationSymbolsInfo = symbolObj;
      this.simulationContractIdByName = idByName;
    },
    async getContractsInfo() {
      try {
        const { $curHost } = useNuxtApp();
        const res: any = await axios({
          baseURL: $curHost.contractApiHostV2,
          url: '/v1/ifcontract/contracts_all',
          method: 'GET',
        });
        if (res.data?.success) {
          const contracts = get(res, ['data', 'data', 'contracts'], []);
          this.SET_CONTRACT_INFOS(contracts);
        } else {
          return [];
        }
      } catch (err) {
        //
      }
    },
    async getSimulationContractsInfo() {
      try {
        const { $curHost } = useNuxtApp();
        const res: any = await axios({
          baseURL: $curHost.demoContractApiHost,
          url: '/v1/ifcontract/simulation/contracts',
          method: 'GET',
          params: {
            isHiddenSimulation: 0,
          },
        });
        if (res.data?.success) {
          const contracts = get(res, ['data', 'data', 'contracts'], []);
          this.SET_SIMULATION_CONTRACT_INFOS(contracts);
        }
      } catch (err) {
        //
      }
    },
  },
});
